import { render } from "./SignatureModal.vue?vue&type=template&id=1b055a0c"
import script from "./SignatureModal.vue?vue&type=script&lang=js"
export * from "./SignatureModal.vue?vue&type=script&lang=js"
script.render = render

export default script